export default {
  "100 requêtes IA par jour": "100 AI requests per day",
  "Votre logo et vos couleurs sur devis et factures": "Your logo and colours on quotes and invoices",
  "Google, Slack et Notion connectés": "Google, Slack and Notion connected",
  "Studio marketing illimité": "Unlimited marketing studio",
  "Idées de croissance chaque semaine": "Growth ideas every week",
  "Rappels par e-mail et mode vocal": "Email reminders and voice mode",
  "300 requêtes IA par jour": "300 AI requests per day",
  "Tout Essentiel": "Everything in Essential",
  "Dictaphone et transcription de réunions": "Voice recorder and meeting transcription",
  "API pour Zapier, Make, n8n": "API for Zapier, Make, n8n",
  "5 Go de stockage": "5 GB of storage",
  "1 000 requêtes IA par jour": "1,000 AI requests per day",
  "Tout Pro": "Everything in Pro",
  "Équipe jusqu'à 50 membres": "Teams of up to 50 members",
  "20 Go de stockage": "20 GB of storage",
  "9 € / mois": "€9 / month",
  "19 € / mois": "€19 / month",
  "39 € / mois": "€39 / month",
  "Disponible avec {0}": "Available with {0}",
  "Débloquez cette fonctionnalité et bien plus encore.": "Unlock this feature and much more.",
  "Formule": "Plan",
  "Cette fonctionnalité fait partie de la formule": "This feature is part of the plan",
  ". Les abonnements ne sont pas gérés dans cette application.": ". Subscriptions are not managed in this app.",
  "Voir les formules": "See plans",
  "Sans engagement, résiliable à tout moment.": "No commitment, cancel anytime.",
  "Rappel GBC Coach IA": "GBC Coach IA reminder",
  "C'est fait": "Done",
  "Dans 10 min": "In 10 min",
  "Transcription impossible.": "Transcription failed.",
  "Enregistrez vos réunions et rendez-vous : la transcription arrive automatiquement, prête pour le compte rendu.": "Record your meetings and appointments: the transcript arrives automatically, ready for the minutes.",
  "La transcription n'est pas encore activée sur ce serveur. Utilisez « Dicter » en attendant.": "Transcription is not enabled on this server yet. Use “Dictate” in the meantime.",
  "Accès au micro refusé. Autorisez-le dans les réglages.": "Microphone access denied. Allow it in your settings.",
  "Enregistrer et transcrire automatiquement": "Record and transcribe automatically",
  "Enregistrer": "Save",
  "· transcription…": "· transcribing…",
  "Terminer": "Finish",
  "Finalisation…": "Finishing…",
  "Chargement": "Loading",
  "Fermer": "Close",
  "Conseil du jour": "Tip of the day",
  "Revenez demain pour un nouveau conseil.": "Come back tomorrow for a new tip.",
  "{0}\n\nPremière étape : {1}": "{0}\n\nFirst step: {1}",
  "Ajoutée à vos tâches.": "Added to your tasks.",
  "Idées de croissance de la semaine": "This week's growth ideas",
  "Nouvelles idées": "New ideas",
  "• Relancer les 3 devis en attente avec une offre limitée": "• Follow up on the 3 pending quotes with a limited-time offer",
  "• Lancer un parrainage auprès de vos meilleurs clients": "• Launch a referral programme with your best customers",
  "• Créer une offre premium à +40 %": "• Create a premium offer at +40%",
  "5 idées sur mesure chaque semaine, d'après votre activité.": "5 tailored ideas every week, based on your business.",
  "Chaque semaine, 5 idées concrètes pour gagner des clients et du chiffre d'affaires.": "Every week, 5 concrete ideas to win customers and revenue.",
  "Débloquer avec Essentiel": "Unlock with Essential",
  "· Effort": "· Effort",
  "Ajouter « {0} » à mes tâches": "Add “{0}” to my tasks",
  "Une nouvelle version de GBC Coach IA est disponible.": "A new version of GBC Coach IA is available.",
  "Plus tard": "Later",
  "Mettre à jour": "Update",
  "Je vous écoute…": "I'm listening…",
  "Je réfléchis…": "Thinking…",
  "Je vous réponds…": "Answering…",
  "Mode vocal": "Voice mode",
  "Parlez naturellement, j'envoie dès que vous marquez une pause.": "Speak naturally, I send as soon as you pause.",
  "Touchez « Passer » pour me couper la parole.": "Tap “Skip” to interrupt me.",
  "Passer": "Skip",
  "Quitter le mode vocal": "Exit voice mode",
  "Nouvelle conversation avec le Coach": "New conversation with the Coach",
  "Créer une tâche": "Create a task",
  "Planifier ma journée en un clic": "Plan my day in one click",
  "Lancer une mission (de l'idée à l'exécution)": "Launch a mission (from idea to execution)",
  "Voir les tâches en retard": "See overdue tasks",
  "Aller à": "Go to",
  "Phase {0}": "Phase {0}",
  "Recherche et commandes": "Search and commands",
  "Rechercher une page, une conversation ou lancer une action.": "Search for a page, a conversation or run an action.",
  "Rechercher une page, une conversation, une action…": "Search for a page, a conversation, an action…",
  "Recherche…": "Searching…",
  "Aucun résultat.": "No results.",
  "Entrée": "Enter",
  "Échap": "Esc",
  "Arrêter la dictée": "Stop dictation",
  "Dicter": "Dictate",
  "Arrêter": "Stop",
  "Titre, début et fin sont requis.": "Title, start and end are required.",
  "Modifier l'événement": "Edit event",
  "Nouvel événement": "New event",
  "Événement récurrent : les modifications s'appliquent à toute la série.": "Recurring event: changes apply to the whole series.",
  "Titre": "Title",
  "Début": "Start",
  "Fin": "End",
  "Rendez-vous / événement": "Appointment / event",
  "Deep Work (concentration)": "Deep Work (focus)",
  "Pause": "Break",
  "Rappel": "Reminder",
  "Aucun": "None",
  "5 min avant": "5 min before",
  "15 min avant": "15 min before",
  "30 min avant": "30 min before",
  "1 h avant": "1 h before",
  "La veille": "The day before",
  "Répétition": "Repeat",
  "Aucune": "None",
  "Tous les jours": "Every day",
  "Jours ouvrés": "Weekdays",
  "Toutes les semaines": "Every week",
  "Tous les mois": "Every month",
  "Jusqu'au": "Until",
  "Toute la journée": "All day",
  "Lieu": "Location",
  "Envoyer vers mon agenda, en un clic (aucun compte à connecter) :": "Send to my calendar in one click (no account to connect):",
  "Google Agenda": "Google Calendar",
  "Une visio Meet s'ouvre : copiez son lien et collez-le dans « Lieu ».": "A Meet video call opens: copy its link and paste it into “Location”.",
  "Créer une visio Meet": "Create a Meet call",
  "Supprimer l'événement": "Delete event",
  "Supprimer toute la série ?": "Delete the whole series?",
  "Supprimer cet événement ?": "Delete this event?",
  "Lien Google Meet ajouté (et rendez-vous créé dans Google Agenda).": "Google Meet link added (and event created in Google Calendar).",
  "Annuler": "Cancel",
  "Modifier le projet": "Edit project",
  "Nouveau projet": "New project",
  "Nom": "Name",
  "Échéance": "Due date",
  "Statut": "Status",
  "Planifié": "Planned",
  "Actif": "Active",
  "En pause": "Paused",
  "Terminé": "Completed",
  "Archivé": "Archived",
  "Couleur": "Colour",
  "Rouvrir la tâche": "Reopen task",
  "Marquer comme terminée": "Mark as done",
  "Coach IA": "AI Coach",
  "À faire": "To do",
  "En cours": "In progress",
  "Bloquée": "Blocked",
  "Terminée": "Done",
  "Annulée": "Cancelled",
  "Création": "Created",
  "Modification": "Edited",
  "Créée par le Coach IA (validée)": "Created by the AI Coach (approved)",
  "Modifiée par le Coach IA (validée)": "Edited by the AI Coach (approved)",
  "Créée par Mission Mode": "Created by Mission Mode",
  "Planifiée": "Scheduled",
  "Créée par une automatisation": "Created by an automation",
  "priorité": "priority",
  "échéance": "due date",
  "durée estimée": "estimated duration",
  "créneau": "time slot",
  "Le titre est requis.": "Title is required.",
  "Modifier la tâche": "Edit task",
  "Nouvelle tâche": "New task",
  "Supprimer la tâche": "Delete task",
  "Supprimer définitivement cette tâche ?": "Permanently delete this task?",
  "Ex. Envoyer la proposition à Martin": "E.g. Send the proposal to Martin",
  "Projet": "Project",
  "Priorité": "Priority",
  "Durée estimée (min)": "Estimated duration (min)",
  "Début du créneau": "Slot start",
  "Fin du créneau": "Slot end",
  "Énergie requise": "Energy required",
  "Non précisée": "Not specified",
  "Haute (concentration)": "High (focus)",
  "Moyenne": "Medium",
  "Faible": "Low",
  "Responsable": "Assignee",
  "Non assignée": "Unassigned",
  "Durée réelle (min)": "Actual duration (min)",
  "Catégorie": "Category",
  "Étiquettes": "Tags",
  "Séparées par des virgules": "Comma-separated",
  "Dépend de": "Depends on",
  "Retirer": "Remove",
  "Tâche": "Task",
  "Ajouter une dépendance": "Add a dependency",
  "Ajouter une dépendance…": "Add a dependency…",
  "Bloque :": "Blocks:",
  "Historique": "History",
  "Origine :": "Origin:",
  "Commentaires": "Comments",
  "Ancien membre": "Former member",
  "Écrire un commentaire…": "Write a comment…",
  "Nouveau commentaire": "New comment",
  "Envoyer": "Send",
  "Basique": "Basic",
  "Par échéance puis priorité.": "By due date, then priority.",
  "Avancé": "Advanced",
  "Durées, disponibilités, dépendances, énergie.": "Durations, availability, dependencies, energy.",
  "Priorités": "Priorities",
  "Importance × urgence (Eisenhower).": "Importance × urgency (Eisenhower).",
  "{0} tâche(s) planifiée(s).": "{0} task(s) scheduled.",
  "Ma journée en un clic": "My day in one click",
  "Journée perturbée ? Replanifiez le reste de la journée à partir de maintenant, en tenant compte de vos rendez-vous.": "Day disrupted? Replan the rest of the day from now, taking your appointments into account.",
  "Un planning proposé à partir de vos tâches, de vos horaires et de votre agenda. Rien n'est modifié sans votre validation.": "A schedule proposed from your tasks, working hours and calendar. Nothing changes without your approval.",
  "Jour": "Day",
  "Aujourd'hui": "Today",
  "Demain": "Tomorrow",
  "Pauses": "Breaks",
  "Recalculer": "Recalculate",
  "Proposer un planning": "Propose a schedule",
  "n'est pas un jour travaillé selon vos préférences (Paramètres › Profil).": "is not a working day in your preferences (Settings › Profile).",
  "planifiées sur": "scheduled out of",
  " — surcharge détectée": " — overload detected",
  "Le travail estimé (": "The estimated work (",
  ") dépasse votre temps libre. Reportez ou déléguez les tâches non planifiées ci-dessous, ou réduisez leur périmètre.": ") exceeds your free time. Postpone or delegate the unscheduled tasks below, or reduce their scope.",
  "Inclure {0}": "Include {0}",
  " · durée par défaut": " · default duration",
  "Aucune tâche à planifier sur les créneaux libres.": "No tasks to schedule in the free slots.",
  "Non planifiées": "Unscheduled",
  "Valider et appliquer": "Approve and apply",
  "Ignorer": "Dismiss",
  "rendez-vous pris en compte": "appointment(s) taken into account",
  "Dim": "Sun",
  "Lun": "Mon",
  "Mar": "Tue",
  "Mer": "Wed",
  "Jeu": "Thu",
  "Ven": "Fri",
  "Sam": "Sat",
  "Échéance : {0}": "Due: {0}",
  "Créer un événement le {0} à {1} h": "Create an event on {0} at {1}:00",
  "Mois précédent": "Previous month",
  "Mois suivant": "Next month",
  ", {0} élément(s)": ", {0} item(s)",
  "+ Ajouter": "+ Add",
  "Rien de prévu. Profitez-en pour avancer sur une priorité.": "Nothing planned. A good time to move a priority forward.",
  "Journée": "All day",
  "Très basse": "Very low",
  "Basse": "Low",
} as Record<string, string>;
